import React from "react";
import { useNavigate } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import Avatar from "../inputs/Avatar";
import { useTranslation } from "react-i18next";

const TableLeaderBoard = ({ usersList }) => {
  const { t } = useTranslation(["common", "leaderboard", "learningPaths"]);
  const navigate = useNavigate();

  return (
    <Table className="table">
      <Thead className="table-header">
        <Tr>
          <Th>{t("employeeName")}</Th>
          <Th>{t("employeeDepartment")}</Th>
          <Th>{t("leaderboard:employeePoints")}</Th>
          <Th>{t("leaderboard:TheCompletedCourses")}</Th>
        </Tr>
      </Thead>
      <Tbody className="table__content">
        {usersList?.data?.map((user) => {
          const isCurrentUser = user?.rank === usersList.current_user_order;

          return (
            <Tr
              key={user.id}
              className={`leader-${user?.rank} ${
                isCurrentUser ? "myself-selected" : ""
              }`}
            >
              <Td>
                <div className="item leader-board">
                  <div
                    className={`leader-board-card leader-board-card--table ${
                      isCurrentUser ? "myself-selected" : ""
                    } leader-${user?.rank}`}
                  >
                    <span className="num me-3 font_14 font-extrabold">
                      {user?.rank}
                    </span>
                    <Avatar
                      width="40"
                      height="40"
                      avatarUrl={user?.avatar_url}
                    />
                    <div className="ms-2 leader-board-user-info">
                      <h1
                        role="button"
                        onClick={() => navigate(`/employee/profile/${user.id}`)}
                        className="mb-0 font_15 font-extrabold text-truncate"
                      >
                        {user?.name}
                        {isCurrentUser && (
                          <span className="ms-2 font-color-grey font_15 font-regular">
                            ({t("you")})
                          </span>
                        )}
                      </h1>
                    </div>
                  </div>
                </div>
              </Td>
              <Td>
                <div className="item">
                  <p className="mb-0 font_14 text-truncate">
                    {user?.department?.name}
                  </p>
                </div>
              </Td>
              <Td>
                <div className="item">
                  <p className="mb-0 font_14">
                    <span className="fas fa-star fa-fw me-2 font-color-gold"></span>
                    <span className="font-extrabold font_16">{user?.points}</span>
                  </p>
                </div>
              </Td>
              <Td>
                <div className="item">
                  <p className="mb-0 font_14">
                    <span className="font-extrabold">
                      {user?.completed_courses_count}
                    </span>{" "}
                    {t("learningPaths:course")}
                  </p>
                </div>
              </Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
};

export default TableLeaderBoard;
